import { render, staticRenderFns } from "./DeptEdit1.vue?vue&type=template&id=39b40a98&scoped=true&"
import script from "./DeptEdit1.vue?vue&type=script&lang=js&"
export * from "./DeptEdit1.vue?vue&type=script&lang=js&"
import style0 from "./DeptEdit1.vue?vue&type=style&index=0&id=39b40a98&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b40a98",
  null
  
)

export default component.exports